/**
 * OneSignal v16 helpers — wraps window.OneSignalDeferred safely.
 * SDK init happens in index.html. These functions just queue actions.
 */

const queue = (fn) => {
  if (typeof window === 'undefined') return;
  window.OneSignalDeferred = window.OneSignalDeferred || [];
  window.OneSignalDeferred.push(fn);
};

/** Tag the current OneSignal subscriber with our app's user_id. */
export const tagOneSignalUser = (userId) => {
  if (!userId) return;
  queue(async (OneSignal) => {
    try {
      await OneSignal.login(String(userId));
    } catch (e) {
      console.warn('[OneSignal] login failed:', e);
    }
  });
};

/** Untag (call on logout). */
export const untagOneSignalUser = () => {
  queue(async (OneSignal) => {
    try {
      await OneSignal.logout();
    } catch (e) {
      console.warn('[OneSignal] logout failed:', e);
    }
  });
};

/** Prompt the user for permission to send web push. */
export const requestOneSignalPermission = () => {
  queue(async (OneSignal) => {
    try {
      await OneSignal.Slidedown.promptPush();
    } catch (e) {
      console.warn('[OneSignal] prompt failed:', e);
    }
  });
};

/** Whether the current browser is opted in (resolves a Promise). */
export const isOneSignalOptedIn = () =>
  new Promise((resolve) => {
    queue((OneSignal) => {
      try {
        resolve(Boolean(OneSignal.User?.PushSubscription?.optedIn));
      } catch {
        resolve(false);
      }
    });
  });
